import type { TFunction } from 'i18next'

import { HttpService } from '@/infra/http'

export type FluxoPagamentoTipoParcela =
  | 'Entrada'
  | 'Mensais'
  | 'Intermediarias'
  | 'Saldo'
  | 'PosConclusao'
  | 'IntermediariasPosConclusao'

export const obterFluxoPagamentoLabel = (t: TFunction<'simulador'>) =>
  ({
    Entrada: String(t('simulador.tipos_parcela.Entrada')),
    Mensais: String(t('simulador.tipos_parcela.Mensais')),
    Intermediarias: String(t('simulador.tipos_parcela.Intermediarias')),
    Saldo: String(t('simulador.tipos_parcela.Saldo')),
    PosConclusao: String(t('simulador.tipos_parcela.PosConclusao')),
    IntermediariasPosConclusao: String(t('simulador.tipos_parcela.IntermediariasPosConclusao')),
  }) as const

export interface IParcelaFluxoPagamento {
  data: string
  tipoDaParcela: FluxoPagamentoTipoParcela
  valor: string
  valorConvertido?: string
}

export interface IFluxoPagamento {
  ano: number
  parcelas: IParcelaFluxoPagamento[]
}

export class GetFluxoPagamentosService extends HttpService {
  execute = async (ids: string[]) => {
    return this.http.get<IFluxoPagamento[]>('api/v2/Simulacao/fluxoPagamento', {
      params: { ids },
      paramsSerializer: { indexes: null },
    })
  }
}
